<template>
  <div class="addAdress">
    <topTitle title="添加地址"></topTitle>
    <van-address-edit
      :area-list="areaList"
      show-set-default
      show-search-result
      :search-result="searchResult"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      :address-info="AddressInfo"
      @save="onSave"
    />
    <!-- @change-detail="onChangeDetail" -->
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
// import areaList from "./area.js";
export default {
  name: "addAdress",
  data() {
    return {
      searchResult: [],
      areaList: {},
      AddressInfo: {
        //收货人信息初始值
        name: "", //姓名
        tel: "", //电话
        province: "", //省份
        city: "", //城市
        country: "", //区县
        areaCode: "", //地址code：ID
        addressDetail: "", //详细地址
        isDefault: false //是否选择默认
      }
    };
  },
  components: {
    topTitle
  },
  created(){
    this.getdata();
  },
  methods: {
    getdata(){
      this.publicGETRequest(`regions/0/children`).then(res => {
          console.log(res.data.data)
          this.areaList.province_list= res.data.data
          this.areaList.city_list= []
          this.areaList.county_list= []
          console.log(res)
      });
    },

    onSave(e) {
      console.log(e,this.AddressInfo)
      this.AddressInfo = e;
      let param = {
        name:this.AddressInfo.name,
        addr:this.AddressInfo.addressDetail,
        tel:'',
        mobile:this.AddressInfo.tel,
        def_addr:this.AddressInfo.isDefault,
        region:this.AddressInfo.areaCode
      };
      this.postRequest(`members/address`, param).then(res => {
          console.log(res)
      });
      //  this.$router.push('./ConfirmationOrder')
    },
    onChangeDetail(val) {
      if (val) {
        this.searchResult = [
          {
            name: "黄龙万科中心",
            address: "杭州市西湖区"
          }
        ];
      } else {
        this.searchResult = [];
      }
    }
  }
};
</script>


<style scoped lang='less'>
.addAdress {
  /deep/ .van-switch--on {
    background-color: #f2170c;
  }
  /deep/ .van-address-edit__buttons {
    padding: 12px 78px;
    position: fixed;
    bottom: 40px;
    width: 100%;
    /deep/ button {
      background: linear-gradient(to right, #f24c0b, #f2170c);
      width: 100%;
      height: 88px;
      line-height: 88px;
      letter-spacing: 2px;
      font-size: 36px;
      color: #fff;
      border-radius: 40px;
      border: transparent;
    }
  }
}
</style>


